<!-- 资讯正文页 地图模块组件 -->
<template>
  <div id="widgetBaiduMap" class="widget-baidu-map-wrapper"></div>
</template>

<script>
import { THIRD_API } from '@/global/config'

export default {
  props: {
    // 地图模块组件
    // 地图经纬度
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      // baidu-map-sdk
      bmap: THIRD_API.bmap.link
    }
  },
  mounted() {
    this.getBaiduMapSDK()
  },
  methods: {
    // 加载baidu-map-sdk
    getBaiduMapSDK() {
      window.onBaiduMapSDKComplete = this.onBaiduMapSDKComplete
      let script = document.createElement('script')
      script.src = `${this.bmap}&callback=window.onBaiduMapSDKComplete`
      document.body.appendChild(script)
    },
    // 加载完成之后，创建地图组件
    onBaiduMapSDKComplete() {
      this.createBaiduMap()
    },
    // 加载完成之后，创建地图组件
    createBaiduMap() {
      const {
        source: { lng, lat, zoom }
      } = this.data
      // 创建地图
      // eslint-disable-next-line
      const map = new BMap.Map('widgetBaiduMap')
      // eslint-disable-next-line
      const point = new BMap.Point(lng, lat)
      map.centerAndZoom(point, zoom)
      map.enableScrollWheelZoom(true)
      // 创建标注
      // 将标注添加到地图中
      // eslint-disable-next-line
      const marker = new BMap.Marker(point)
      map.addOverlay(marker)
    }
  }
}
</script>

<style lang="scss" scoped>
/*地图模块组件*/
.widget-baidu-map-wrapper {
  width: 800px;
  height: 437px;
  margin: 16px auto;
  border-radius: 8px;
}
</style>
